import { FC, SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {}

export const DesktopLogoIcon: FC<Props> = (props) => {
    return (
        <svg width="761" height="300" viewBox="0 0 761 300" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M455.19 105.91H408.9V236.31H379.53V105.91H332.8V80.54H455.19V105.91Z" fill="currentColor" />
            <path
                d="M543.31 188.47H461.2C464.09 204.94 475.89 215.84 491.02 215.84C502.37 215.84 511.49 210.72 517.06 202.27L538.87 215.4C527.74 230.31 509.5 239.21 491.03 239.21C460.55 239.21 434.07 214.96 434.07 180.24C434.07 145.52 460.33 121.5 489.7 121.5C528.18 121.49 547.09 152.2 543.31 188.47ZM462.09 167.77H516.83C513.49 153.31 504.15 144.18 489.68 144.18C476.11 144.19 465.87 153.53 462.09 167.77Z"
                fill="currentColor"
            />
            <path
                d="M601.61 236.75C597.38 237.64 592.93 237.86 588.93 237.86C569.35 237.86 560.67 228.51 560.67 209.6V80.54H588.04V205.82C588.04 215.39 593.83 216.72 601.61 215.83V236.75Z"
                fill="currentColor"
            />
            <path
                d="M615.85 93.45C615.85 84.77 623.42 77.65 632.09 77.65C640.55 77.65 648.11 84.77 648.11 93.45C648.11 102.13 640.54 109.25 632.09 109.25C623.42 109.25 615.85 102.13 615.85 93.45ZM618.3 236.31V125.05H645.67V236.31H618.3Z"
                fill="currentColor"
            />
            <path
                d="M760.71 157.54V236.31H735.12V223.4C726.44 234.75 712.64 238.98 701.07 238.98C677.04 238.98 662.8 223.85 662.8 204.93C662.8 183.35 687.06 165.77 716.65 165.77C722.44 165.77 728.67 166.22 734.23 168V160.66C734.23 149.53 727.78 143.75 714.65 143.75C702.86 143.75 692.4 149.76 685.95 157.55L666.59 143.31C677.49 130.63 696.19 121.73 715.1 121.73C744.69 121.71 760.71 134.62 760.71 157.54ZM734.23 193.36V188.46C729.78 186.9 725.11 186.46 719.32 186.46C699.29 186.46 689.06 194.47 689.06 204.26C689.06 212.27 695.96 217.39 706.42 217.39C720.21 217.39 734.23 209.16 734.23 193.36Z"
                fill="currentColor"
            />
            <path
                d="M196.36 210.79C235.26 188.23 270.3 149.97 281.35 122.69C284.49 100.11 285.13 97.26 285.51 72.42C285.56 68.98 285.35 65.68 285.03 62.52C282.76 99 235.61 144.87 173.23 174.84C97.98 210.99 41.53 220.72 16.34 193.15C25.09 210.43 30.83 218.82 40.67 231.64C69.73 257.38 130.89 248.77 196.36 210.79Z"
                fill="currentColor"
            />
            <path
                d="M164.46 148.99C235.44 114.75 284.88 66.04 276.26 33.75C262.11 9.31 233.47 0 202.76 0C111.73 0 0 60 0 136.55C0 146.39 2.17 157.39 6.06 168.92C26.82 196.47 90.3 184.76 164.46 148.99Z"
                fill="currentColor"
            />
            <path
                d="M158.47 257.49C108.55 277.73 79.98 271.28 64.19 258.66L63.96 258.48C88.4 282.86 116.26 300.01 140.69 300.01C183.47 300.01 242.04 248.11 269.76 167.63C254.14 196.68 220.62 232.37 158.47 257.49Z"
                fill="currentColor"
            />
        </svg>
    );
};
